module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_29.be3585a3.pdf";